<template>
    <div class="body">
        <el-card class="login_card">
            <div class="mode_title">用户数据</div>
            <div class="left_div">
                <div class="login_div">
                    <div class="title"><el-icon><UserFilled /></el-icon> 今日登陆量</div>
                    <div class="num">{{indexData.todayLoginNum}}</div>
                </div>
                <div class="login_div">
                    <div class="title"><el-icon><UserFilled /></el-icon> 今日微信登录量</div>
                    <div class="num">{{indexData.todayWxLoginNum}}</div>
                </div>
                <div class="login_div" style="margin-top: 20px">
                    <div class="title"><el-icon><UserFilled /></el-icon> 今日苹果登录量</div>
                    <div class="num">{{indexData.todayIosLoginNum}}</div>
                </div>

            </div>
        </el-card>

        <el-card class="login_card" style="margin-left: 10%">
            <div class="mode_title">金额模块</div>
            <div class="left_div">
                <div class="login_div">
                    <div class="title"><el-icon><Money /></el-icon> 今日提现总金额</div>
                    <div class="num">￥{{ Number(indexData.todayTotalMoney || 0).toFixed(2) }}</div>
                </div>
                <div class="login_div">
                    <div class="title"><el-icon><Money /></el-icon> 今日非审核提现总金额</div>
                    <div class="num">￥{{ Number(indexData.todayUnCheckMoney || 0).toFixed(2) }}</div>
                </div>
                <div class="login_div" style="margin-top: 20px">
                    <div class="title"><el-icon><Money /></el-icon> 今日审核提现总金额</div>
                    <div class="num">￥{{ Number(indexData.todayCheckMoney || 0).toFixed(2) }}</div>
                </div>
                <div class="login_div" style="margin-top: 20px">
                    <div class="title"><el-icon><Money /></el-icon> 本月提现总金额</div>
                    <div class="num">￥{{ Number(indexData.monthTotalMoney || 0).toFixed(2) }}</div>
                </div>
            </div>
        </el-card>

        <el-card class="login_card" style="margin-top: 40px" >
            <div class="mode_title">ECPM模块</div>
            <div class="left_div">
<!--                <div class="login_div">-->
<!--                    <div class="title"><el-icon><Money /></el-icon>历史ECPM总量</div>-->
<!--                    <div class="num">{{ Number(indexData.totalEcpm || 0).toFixed(2) }}</div>-->
<!--                </div>-->
                <div class="login_div">
                    <div class="title"><el-icon><Money /></el-icon> 今日ECPM总量</div>
                    <div class="num">{{ Number(indexData.todayTotalEcpm || 0).toFixed(2) }}</div>
                </div>
            </div>
        </el-card>

        <el-card class="login_card" style="margin-top: 40px;margin-left: 10% ">
             <div class="mode_title">邀请模块</div>
             <div class="left_div">
                 <div class="login_div">
                     <div class="title"><el-icon><UserFilled /></el-icon>当前被邀请人的总数</div>
                     <div class="num">{{indexData.totalInviteeCount}}</div>
                 </div>
                 <div class="login_div">
                     <div class="title"><el-icon><Money /></el-icon> 被邀请人产生的所有类型的ECPM总额</div>
                     <div class="num">{{ Number(indexData.totalInviteeEcpmAmount || 0).toFixed(2) }}</div>
                 </div>
                 <div class="login_div">
                     <div class="title"><el-icon><Money /></el-icon> 被邀请人产生的分成总额</div>
                     <div class="num">{{ Number(indexData.totalShareAmount || 0).toFixed(2) }}</div>
                 </div>
             </div>
        </el-card>
    </div>
    <router-view/>
</template>

<script>
    import {getPage, total} from '../../api/user/user';
    import {ElMessage} from 'element-plus';
    export default {
        dialogVisible: true,
        name: "Index",

        data() {
            return {
                labelPosition: 'right',
                total:0,
                dialogVisible: false,
                indexData: {},
                name: '',
                region: '',
                loginList: [
                    {
                        "id":1,
                        "title":""
                    }
                ],
                searchCondition: {
                    page: 1,
                    size: 10,
                    uid: "",
                    nickname: '',
                },
                loading: false,
            }
        },
        mounted() {
            this.selectData();
        },
        methods: {
            // 查询
            selectData() {
                this.loading = true;
                total().then(res => {
                    const code = res.data.code;
                    if (code === "200") {
                        const indexData = res.data.data;
                        console.log("records:" + JSON.stringify(indexData));
                        this.indexData = indexData;
                        this.total = total;
                        this.loading = false;
                    }
                }).catch(error => {  // 加上catch即可
                    console.log(error);
                });
            },


        }
    }
</script>

<style lang="less" scoped>
   .body{
       margin-top: 40px;
       display: flex;
       flex-wrap: wrap;
       justify-content: start;
       padding: 20px;
       width: 90%;
       margin-left: 5%;
   }

   .mode_title{
       font-weight: 700;
       font-size: x-large;
   }


    .login_card{


        width: 36%;
        .left_div{
            margin-top: 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: start;
            width: 100%;
            .login_div{
                width: 50%;
            }
        }
    }

   .title{
       font-size: small;
       color: gray;
   }
   .num{
       margin-top: 10px;
       font-size: large;
   }

    .money_card{
        width: 45%;
    }


</style>
